import React from 'react';
import { GLOBAL_CONSTANTS } from 'js/common/constants/GlobalConstants';

class ModalComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
        this._handleKeyDown = this._handleKeyDown.bind(this);
        
        if ( typeof document === "object") {
            document.addEventListener("keydown", this._handleKeyDown);      
        }
    };
    

    render() {
        return (
            <div id="modal" className={ this.props.modalCfg.modalCls }>
                <div className="modal_body pos_rel">
                    <div className='modal_header full_width modal_header_bg '>
                        <span className='float_left color_white header_text bold pos_rel'>{ this.props.modalCfg.headerText }</span>
                        <span title='close' className='float_right icon-close modal_close color_white pos_rel cur_pointer' onClick={ this.closeModal.bind(this) }></span>
                    </div>               
                    {
                        this.props.children
                    }
                </div>
            </div>
        )
    };

    /* istanbul ignore next */
    closeModal() {
        if (this.props.modalCfg && this.props.modalCfg.onClose) {
            this.props.modalCfg.onClose();
        }
    };

    /* istanbul ignore next */
    _handleKeyDown(event) {
        switch( event.keyCode ) {
            case GLOBAL_CONSTANTS.ESCAPE_KEY:
                if ( !this.props.store.getState().appData.appData.showMask ) {
                    if ( document.getElementById('rtf_link_box_close') )
                        document.getElementById('rtf_link_box_close').click();
                    else if ( !this.props.store.getState().messageData.messageData || !this.props.store.getState().messageData.messageData.show ) 
                        this.closeModal();
                }

                break;
            default: 
                break;
        }
    };

    /* istanbul ignore next */
    componentWillUnmount() {
        document.removeEventListener("keydown", this._handleKeyDown);
    };
}

export default ModalComponent;